import { useEffect, useState } from "react";
import { CloudUpload, CheckCircle2, XCircle } from "lucide-react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";

export default function AdminSettings() {
  const [driveStatus, setDriveStatus] = useState(null);
  const API = process.env.REACT_APP_BACKEND_URL + "/api";

  useEffect(() => {
    api.get("/admin/drive-auth/status").then(({ data }) => setDriveStatus(data));
  }, []);

  const connectDrive = () => {
    // Full navigation to Google's consent screen, handled entirely by the backend
    window.location.href = `${API}/admin/drive-auth/start`;
  };

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-slate-800 bg-[#121820] p-6 space-y-3" data-testid="admin-settings-panel">
        <h3 className="text-sm font-bold uppercase tracking-widest text-slate-300">Paramètres généraux</h3>
        <p className="text-sm text-slate-500">
          Cette application utilise exclusivement Google Sheets (données) et Google Drive (photos/QR codes) comme source de vérité — aucune base de données externe.
        </p>
        <div className="grid sm:grid-cols-2 gap-4 pt-2 text-sm">
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Source de données</div>
            <div className="text-slate-300">Google Sheets</div>
          </div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Stockage des photos / QR</div>
            <div className="text-slate-300">Google Drive — Inspections_Photos / Configuration/QR_Fronts</div>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-slate-800 bg-[#121820] p-6 space-y-3" data-testid="admin-drive-auth-panel">
        <h3 className="text-sm font-bold uppercase tracking-widest text-slate-300 flex items-center gap-2">
          <CloudUpload className="w-4 h-4 text-cyan-400" /> Connexion Google Drive
        </h3>
        <p className="text-sm text-slate-500">
          Les comptes de service Google n'ont pas de quota de stockage propre. Connectez un compte Google
          personnel/professionnel pour autoriser l'upload réel des photos et QR codes dans Drive.
        </p>
        {driveStatus && (
          <div data-testid="admin-drive-auth-status" className="flex items-center gap-2 text-sm">
            {driveStatus.connected ? (
              <span className="flex items-center gap-1.5 text-emerald-400 font-semibold"><CheckCircle2 className="w-4 h-4" /> Drive connecté</span>
            ) : (
              <span className="flex items-center gap-1.5 text-amber-400 font-semibold"><XCircle className="w-4 h-4" /> Drive non connecté</span>
            )}
          </div>
        )}
        {driveStatus && !driveStatus.configured && (
          <p data-testid="admin-drive-auth-not-configured" className="text-xs text-red-400">
            Configuration OAuth manquante côté serveur (GOOGLE_OAUTH_CLIENT_ID/SECRET). Contactez le support Emergent.
          </p>
        )}
        <Button
          data-testid="admin-drive-connect-button"
          onClick={connectDrive}
          disabled={!driveStatus?.configured}
          className="bg-cyan-500 hover:bg-cyan-400 disabled:opacity-40 text-black font-bold uppercase text-xs"
        >
          {driveStatus?.connected ? "Reconnecter Google Drive" : "Connecter Google Drive"}
        </Button>
      </div>
    </div>
  );
}
